<template>
  <footer class="main-footer">
    <hr>
    <section class="logo container">
      <div class="logo__img">
        <img src="../assets/logo.png" alt="Sequire Logo">
      </div>
      <div class="logo__links">
        <a href="https://www.srax.com/terms-of-use/" target="_blank">
          Terms & Conditions
        </a>
        <a href="https://www.srax.com/privacy-policy/" target="_blank">
          Privacy Policy
        </a>
      </div>
    </section>
  </footer>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/footer.scss';
</style>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    };
  },
};
</script>